export default __webpack_public_path__ + "static/media/chart2.c86794cd.png";